import { isMacOS } from "./ua-utils";

const FONT_FAMILY_MACOS = "-apple-system, system-ui, BlinkMacSystemFont, Helvetica, sans-serif";
const FONT_FAMILY_OTHERS = "Inter, system-ui, \"Segoe UI\", sans-serif";
const FONT_FAMILY = isMacOS() ? FONT_FAMILY_MACOS : FONT_FAMILY_OTHERS;
const FONT_FAMILY_KONVA = "Inter, system-ui, sans-serif";
const FONT_FAMILY_STRIPE = "-apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif";

export {
    FONT_FAMILY,
    FONT_FAMILY_KONVA,
    FONT_FAMILY_STRIPE
};
